import {urlEncodedValue} from './urlEncodedValue';

export const urlData = (url, settings) => {
  const requiredVariables = url.match(/(?<!\$){\$*[\da-z]+}/gi);
  const optionalVariables = url.match(/(?<!\$){\/\$*[\da-z]+}/gi);
  const urlData = settings.urlData;
  const encodeParameters = settings.encodeParameters;

  let requestUrl = url;

  if (requiredVariables) {
    $.each(requiredVariables, function(index, templatedString) {
      const variable = templatedString.slice(1, -1);
      const value = urlData[variable];
      if (value !== undefined) {
        requestUrl = requestUrl.replace(templatedString, encodeParameters ? urlEncodedValue(value) : value);
      }
    });
  }

  if (optionalVariables) {
    $.each(optionalVariables, function(index, templatedString) {
      const variable = templatedString.slice(2, -1);
      const value = urlData[variable];
      if (value !== undefined) {
        requestUrl = requestUrl.replace(templatedString, encodeParameters ? urlEncodedValue(value) : value);
      } else {
        requestUrl = requestUrl.indexOf('/' + templatedString) !== -1
            ? requestUrl.replace('/' + templatedString, '')
            : requestUrl.replace(templatedString, '');
      }
    });
  }

  return requestUrl;
}